import { render, staticRenderFns } from "./DraggableComponent.vue?vue&type=template&id=0308bf59&scoped=true"
import script from "./DraggableComponent.vue?vue&type=script&lang=js"
export * from "./DraggableComponent.vue?vue&type=script&lang=js"
import style0 from "./DraggableComponent.vue?vue&type=style&index=0&id=0308bf59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0308bf59",
  null
  
)

export default component.exports